import { Outlet} from "react-router";

const Services = () => {
  return (
    <>
    <Outlet />
    </>
  );
};

export default Services;
